/** Figma `TrendIcon` 세트(Components, 2030:2486)의 direction 축 */
export const TREND_DIRECTIONS = ['up', 'down', 'flat'] as const;
export type TrendDirection = (typeof TREND_DIRECTIONS)[number];

/** 모양 색. 오름 = 빨강, 내림 = 파랑(`dataviz/trend/*`) */
export const TREND_COLOR_CLASS: Record<TrendDirection, string> = {
  up: 'fill-dataviz-trend-up',
  down: 'fill-dataviz-trend-down',
  flat: 'stroke-dataviz-trend-flat',
};
